import React from "react";
import UsedCarsWorkspace from "../components/UsedCarsWorkspace";

export default function UsedCarsDocumentationPage() {
  return <UsedCarsWorkspace stage="documentation" />;
}
